import * as React from 'react';
import { StyleSheet } from 'react-native';
import Svg, { Circle, Ellipse, G, Mask } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

function SvgComponent(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={25} height={24} viewBox="0 0 25 24" {...props} fill="none">
            <Circle cx={12.3003} cy={12} r={9} stroke={props.fill || designSystem.colors.gray3} strokeWidth={1.75} />
            <Circle
                cx={12.3003}
                cy={10.5}
                r={3.5}
                stroke={props.fill || designSystem.colors.gray3}
                strokeWidth={1.75}
            />
            <Mask id="a" style={styles.mask} maskUnits="userSpaceOnUse" x={2} y={2} width={21} height={20}>
                <Circle cx={12.3003} cy={12} r={9} fill="#43444F" stroke="#43444F" strokeWidth={1.75} />
            </Mask>
            <G mask="url(#a)">
                <Ellipse
                    cx={12.3003}
                    cy={25}
                    rx={10}
                    ry={8}
                    stroke={props.fill || designSystem.colors.gray3}
                    strokeWidth={1.75}
                />
            </G>
        </Svg>
    );
}

export default SvgComponent;

const styles = StyleSheet.create({
    mask: {
        maskType: 'alpha',
    },
});
